import initialState from "../initialState";

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'preloaderDisplay': {
            return {
                ...state,
                preloader: {
                    ...state.preloader,
                    display: action.display
                }
            }
        }
        case 'changeCity': {
            return {
                ...state,
                select:  {
                    ...state.select,
                    selectedCity: action.cityId
                }
            }
        }
        case 'setCurrentWeather': {
            return {
                ...state,
                currentWeatherData: action.data
            }
        }
        case 'setForecastWeather': {
            return {
                ...state,
                forecastWeatherData: action.data
            }
        }
        case 'imgLoaded': {
            return {
                ...state,
                weatherIcon: {
                    ...state.weatherIcon,
                    imgLoaded: action.isLoaded,
                    width: action.width,
                    height: action.height
                }
            };
        }
        case 'error': {
            return {
                ...state,
                error: action.error
            }
        }
        default: {
            return state;
        }
    }
}
